import individualWorkSupportUtil from '../../../../../share/util/individualWorkSupportUtil';
import session from '../../../../../share/session';
import error from '../../../../../common/nodejs/errors';
import util from '../../../../../share/util/utils';
import { REQUEST_STATUS_COMPLETED } from '../../../../../../../share/src/util/api/polling';
import { PHASE } from './constants';
import { terminate } from './terminate';

/** 
 * 発生日時読み出し処理
 * @param {object} self this インスタンス
 */
export async function read(self) {
  try {
    self.isLoading = true;
    // バックエンドAPI POST,GET
    const token = session.getToken();
    const response = await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        is_special: true,
        type: 'read',
      },
      // エラー発生のコールバックを実装
      async (errorType) => { errorType; await self.showUnexpectedError(); },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      async (result) => { await self.validateErrorResult(result); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      async (result) => { await self.validateErrorResult(result); },
    );

    if (!response) {
      // pollingWspApiはエラーコールバックの終了を待たずnullを返す
      // 非同期処理を含んでいるshowUnexpectedErrorが呼ばれた場合、スピナー消えてしまうためPromiseの解決を待つ
      if (self.exitPromise) await self.exitPromise;
      return;
    }

    // 正常コールバック
    if (response.data?.status === REQUEST_STATUS_COMPLETED) {
      // 保存履歴表示画面の一覧を作成
      await setHistoryList(self, response.data.user_data);
      // 保存履歴表示に遷移
      self.phase = PHASE.HISTORY_LIST;
    } else {
      // 発生日時読み出し失敗の場合
      switch (response.data?.async_code) {
        case error.WSP_DID_IS_NOT_SUPPORTED_ERROR:
          // DefaultSession遷移
          await terminate(self);
          // 失敗表示に遷移
          self.phase = PHASE.FAILED_READ;
          break;
        default:
          // 共通エラー
          await self.showUnexpectedError();
          break;
      }
    }
  } finally {
    self.isLoading = false;
  }
}

/**
 * 保存履歴表示画面で表示する項目を作成
 * @param {object} self this インスタンス
 * @param {object} readData 保存履歴情報
 */
async function setHistoryList(self, readData) {
  self.historyList = readData;
  self.historyList = self.historyList.map(item => ({
    did: item.did,
    date: item.date ? util.timeConverter(new Date(item.date)) : '-', // GMTをLocalTimeに変換
    igon: item.igon,
    displayName: self.$t(`${self.i18nWsKey}.rab_operational_Record_Images`),
    selected: false,
  }));
}
